import React, { useState, useEffect } from "react";
import { Navigate, useLocation } from "react-router-dom";
// import { useAppSelector } from "../../store/hooks";
import { useAppState } from "../../hooks/useAppState";
import { Loader } from "lucide-react";

interface ProtectedRouteProps {
  allowed: string[];
  element: React.ReactElement;
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({
  allowed,
  element,
}) => {
  const [loading, setLoading] = useState(true);
  // Fix for potential undefined auth state
  const {  isAuthenticated } = useAppState();
  const {  user } = useAppState();
  const location = useLocation();
// const user = localStorage.getItem("user") ? JSON.parse(localStorage.getItem("user") || "{}") : null;
  useEffect(() => {
    // Give a short delay to allow authentication data to load
    const timer = setTimeout(() => {
      setLoading(false);
    }, 1000);

    return () => clearTimeout(timer);
  }, [user, isAuthenticated]);

  // Show loader while authentication data is being fetched
  if (loading) {
    return (
      <div className="flex h-screen items-center justify-center">
        <Loader className="animate-spin text-[#F15D18]" size={24} />
      </div>
    );
  }

  // If not authenticated, redirect to login
  if (!isAuthenticated ) {
    console.log("User not authenticated, redirecting to signin");
    // Preserve current search params and keep the from location in state
    return (
      <Navigate
        to={`/signin${location.search}`}
        replace
        state={{ from: location }}
      />
    );
  }

  if (user && !allowed.includes(user?.role || "")) {
    console.log(
      "User doesn't have required role, redirecting to appropriate dashboard"
    );
    if (user?.role === "supporty_admin") {
      return <Navigate to={`/admin/dashboard${location.search}`} replace />;
    } else if (user?.role === "Expert") {
      return <Navigate to={`/expert/dashboard${location.search}`} replace />;
    } else if (user?.role === "Customer") {
      return <Navigate to={`/user/dashboard${location.search}`} replace />;
    }
    return <Navigate to={`/${location.search}`} replace />;
  }

  return element;
};

export default ProtectedRoute;
